import { useMemo } from 'react';

import { COMPONENT_CALLER_TYPE } from 'commons/constants';
import usePDPOptions from 'components/consumer/PDP/state/context/usePDPOptions';
import usePDPClearanceData from 'data-hooks/useClearanceData/usePDPClearanceData';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';

const usePDPProductLabel = (id, slug, hookOptions = {}) => {
  const { productSku } = hookOptions;

  const {
    loading: basicLoading,
    error: basicError,
    data: basicData,
  } = usePDPBasicDetails(id, slug, {
    skipPDPStateHook: false,
    productSku,
  });

  const productOptionData = usePDPOptions();

  const {
    loading: optionsLoading,
    error: optionsError,
    data: optionsData,
  } = productOptionData;

  const {
    error: clearanceDataError,
    data: clearanceData,
  } = usePDPClearanceData(id, slug, { callerType: COMPONENT_CALLER_TYPE.PDP });

  const { isClearance } = clearanceData;

  const productLabel = useMemo(() => {
    let label = null;
    if (
      optionsData?.stock?.isSelectedOptionsQuickship &&
      optionsData.stock.selectedOptionsStockQty <= 3
    ) {
      label = 'Low Stock';
    }
    // higher priority is 'Clearance'
    if (isClearance) {
      label = 'Final Sale';
    }
    // highest priority is `product_label` Custom Property
    if (basicData?.custom_properties?.product_label?.[0]) {
      label = basicData?.custom_properties?.product_label;
    }
    return label;
  }, [
    basicData?.custom_properties?.product_label,
    isClearance,
    optionsData?.stock?.isSelectedOptionsQuickship,
    optionsData?.stock?.selectedOptionsStockQty,
  ]);

  return {
    loading: basicLoading || optionsLoading,
    error: basicError || optionsError || clearanceDataError,
    data: {
      productLabel,
    },
  };
};

export default usePDPProductLabel;
